module.exports = __webpack_public_path__ + "media/audio22.98dfe782.mp3";